// Copyright (c) 2019+,COMUNICARE SOLUTIONS SA
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without modification,
// are NOT permitted.

import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ITranslationKv } from "../models/sharedInterfaces";

/**
 * Take the translation of the field i18n of the mongo document
 */
@Pipe({
  name: "customTranslate",
})
export class CustomTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  public transform(obj: any, key: string): string {
    if (obj && Object.prototype.hasOwnProperty.call(obj, "i18n")) {
      const translations = this.getCurrentLangTranslations(obj.i18n);
      if (translations) {
        const t = translations.find((v) => v.key === key);
        if (t) {
          return t.value;
        }
      }
    }

    if (obj && Object.prototype.hasOwnProperty.call(obj, key)) {
      return obj[key];
    }

    return "";
  }

  private getCurrentLangTranslations(i18n: ITranslationKv[]): [{ key: string; value: string }] | null {
    if (i18n) {
      const trans = i18n.find((t: ITranslationKv) => t.lang === this.translateService.currentLang);
      if (trans) {
        return trans.values;
      }
    }

    return null;
  }
}
